import { IMarketData } from "./MarketsTable";
import { MarketFiltersEnum } from "./CommandModal.types";

export const perpCategoryFilters = [
  MarketFiltersEnum.CRYPTO,
  MarketFiltersEnum.STOCKS,
  MarketFiltersEnum.COMMODITIES,
  MarketFiltersEnum.FX,
  MarketFiltersEnum.INDICES,
  MarketFiltersEnum.PRE_IPO,
];

export const marketFilterOptions = [
  MarketFiltersEnum.ALL_MARKETS,
  MarketFiltersEnum.WATCHLIST,
  ...perpCategoryFilters,
];

export const normalizeMarketCategory = (
  category?: string,
  isPrelaunch?: boolean
): MarketFiltersEnum => {
  const normalized = category?.trim().toLowerCase();
  if (isPrelaunch || normalized === "pre-ipo" || normalized === "pre ipo") {
    return MarketFiltersEnum.PRE_IPO;
  }
  if (normalized === "stocks") return MarketFiltersEnum.STOCKS;
  if (normalized === "commodities") return MarketFiltersEnum.COMMODITIES;
  if (normalized === "fx") return MarketFiltersEnum.FX;
  if (normalized === "indices") return MarketFiltersEnum.INDICES;
  return MarketFiltersEnum.CRYPTO;
};

export const sortWatchlist = (a: IMarketData, b: IMarketData) => {
  if (a.isWatchlist && !b.isWatchlist) {
    return -1;
  }
  if (!a.isWatchlist && b.isWatchlist) {
    return 1;
  }
  return 0;
};

// millis
export const swrUpdateMillis = 5000;
